import {
  AddressAsText,
  AddressPreviewPresentational,
  NamePresentational,
} from '../../types/common';

export type MergeDeliveryInfoParams = {
  description?: string | null;
  title?: string | null;
};

export const strings = {
  convertToString: (value?: string | null) => value || '',

  convertToStringWithSpace: (value?: string | null) => value ? `${value} ` : '',

  mergeStrings: (values: (string | null | undefined)[]): string => {
    let merged = '';

    values.forEach((value) => merged += strings.convertToStringWithSpace(value));

    return merged.trimRight();
  },

  mergeName: ({ firstName, lastName }: NamePresentational): string =>
    strings.mergeStrings([firstName, lastName]),

  mergeAddressPreview: ({
    postCode,
    houseNumber,
    suffix,
    street,
    city,
    addressLine1,
    addressLine2,
  }: AddressPreviewPresentational): AddressAsText => {
    let streetAndHouseNumberAndSuffix: string;
    let postCodeAndCity: string;

    switch (CONFIG.applicationBuild) {
      case 'GCUK':
        streetAndHouseNumberAndSuffix = strings.mergeStrings([addressLine1, addressLine2]);
        postCodeAndCity = strings.mergeStrings([city, postCode]);
        break;
      default:
        streetAndHouseNumberAndSuffix = strings.mergeStrings([street, houseNumber, suffix]);
        postCodeAndCity = strings.mergeStrings([postCode, city]);
    }
    return { streetAndHouseNumberAndSuffix, postCodeAndCity };
  },

  mergeDeliveryInfo: ({ title, description }: MergeDeliveryInfoParams): string =>
    strings.mergeStrings([title, description]),
};
